module.exports = __webpack_public_path__ + "static/img/zd02.f531b825.svg";